function showToast(msg = "", last = 2000, duration = 1000) {
    if (!document.getElementById('css_tips_pop')) {
        var css = document.createElement('style');
        css.type = 'text/css';
        css.id = 'css_tips_pop';
        css.innerHTML =
            `.toast{width:100%;left:0;top:70%;margin-top:-20px;position:fixed;z-index:5201;text-align:center;}.toast span{line-height:1.15;background-color:rgba(0,0,0,0.7);box-shadow:0px 6px 9px 0px rgba(44,7,106,0.3);padding:0.24rem 0.48rem;display:inline-flex;justify-content:center;align-items:center;margin:0 auto;color:#fff;border-radius:0.24rem;font-size:0.28rem;}\
                    .toast-ani {animation: toast-ani 1s ease-in-out 1;-webkit-animation: toast-ani 1s ease-in-out 1;opacity:0;}\
                    @keyframes toast-ani {from {opacity:1;}to {opacity:1;}}\
                    @-webkit-keyframes toast-ani {from {opacity:1;}to {opacity:1;}}`;
        document.getElementsByTagName('head')[0].appendChild(css);
    }

    if (document.getElementById("mod_tips_pop")) {
        // document.getElementById("mod_tips_pop").parentNode.removeChild(document.getElementById("mod_tips_pop"));
    }
    var div = document.createElement("div");
    var span = document.createElement("span");
    var spantext = document.createTextNode(msg);
    div.id = "mod_tips_pop";
    div.className = "toast";
    span.appendChild(spantext);
    div.appendChild(span);
    document.body.appendChild(div);

    setTimeout(function () {
        div.className = "toast toast-ani";
        setTimeout(function () {
            if (document.getElementById("mod_tips_pop")) {
                document.getElementById("mod_tips_pop").parentNode.removeChild(document.getElementById("mod_tips_pop"));
            }
        }, duration);
    }, last)

}
export { showToast }


// WEBPACK FOOTER //
// ./src/pages/act/202010/unit_member/js/toast.js